import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'date-interval-field',
  templateUrl: './date-interval-field.component.html',
  styleUrls: ['./date-interval-field.component.scss']
})
export class DateIntervalFieldComponent {

  @Input() dateFrom: Date;
  @Output() dateFromChange = new EventEmitter();

  @Input() dateTo: Date;
  @Output() dateToChange = new EventEmitter();

  @Output() change = new EventEmitter();

  today = new Date();

  constructor() { }
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/date-interval-field/date-interval-field.component.ts